import { useEffect, useState } from 'react'

export const PREFERRED_HLS_VERSION = '1.4.12'

export const useBrowserSupportsHls = () => {
  const [browserSupportsHls, setBrowserSupportsHls] = useState(true)

  useEffect(() => {
    const video = document.createElement('video')
    setBrowserSupportsHls(
      Boolean(
        video.canPlayType('application/vnd.apple.mpegURL') ||
          video.canPlayType('application/x-mpegURL')
      )
    )
  }, [])

  return browserSupportsHls
}

export const isHlsFile = (filePath: string): boolean => {
  return filePath.indexOf('.m3u8') > -1
}
